import { render, staticRenderFns } from "./WaybillDetail.vue?vue&type=template&id=3206a739&"
import script from "./WaybillDetail.vue?vue&type=script&lang=js&"
export * from "./WaybillDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaybillDetail.vue?vue&type=style&index=0&id=3206a739&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports